import { error, tabaPayError } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

const DeleteExternalCard = gql`
  mutation DeleteExternalCard($input: DeleteExternalCardInput!) {
    deleteExternalCard(input: $input) {
      __typename
      ... on DeleteExternalCardResultSuccess {
        success
      }
      ... on DeleteExternalCardResultError {
        ...error
      }
      ... on TabaPayCustomError {
        ...tabaPayError
        __typename
      }
    }
  }
  ${error}
  ${tabaPayError}
`;

export default DeleteExternalCard;
